import { render, staticRenderFns } from "./iconDominicanFlag.vue?vue&type=template&id=197384ce&scoped=true"
import script from "./iconDominicanFlag.vue?vue&type=script&lang=js"
export * from "./iconDominicanFlag.vue?vue&type=script&lang=js"
import style0 from "./iconDominicanFlag.vue?vue&type=style&index=0&id=197384ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197384ce",
  null
  
)

export default component.exports